export const line = {
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            properties: {
                line_color:      { type: 'color' },
                line_width:      { type: 'int', min: 0 },
                line_rounded:    { type: 'bool' },
                // Genuinely read by lv_obj_init_draw_line_dsc for LINE_PART_MAIN —
                // dash-line rendering, previously entirely unavailable in the designer.
                line_dash_width: { type: 'int', min: 0, label: 'line dash width' },
                line_dash_gap:   { type: 'int', min: 0, label: 'line dash gap' },
                line_opa:        { type: 'int', min: 0, max: 255, internal: true },
            },
        },
    },

    properties: {
        haspid:    { type: 'int', min: 1, max: 254, internal: true },
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        hidden:    { type: 'bool' },
        // LINE gets click=true unconditionally at object creation (hasp_object.cpp:744),
        // so PRESSED/DISABLED are genuinely reachable — enabled drives the disabled state.
        enabled:   { type: 'bool' },
        points:    { type: 'array' },
        // auto_size/y_invert: LVGL's raw creation defaults are auto_size=true,
        // y_invert=false (lv_line.c). The designer intentionally defaults to
        // the opposite (auto_size=0, y_invert=1) as an editor-authoring
        // convention, not a firmware-parity bug — see HaspLine.js's
        // constructor/objectExport comments for the coordinate-transform
        // rationale (bottom-up point authoring reconciled with Konva's
        // top-down canvas). This is safe because HaspLine.js's objectExport()
        // always writes both keys explicitly on every export, so firmware's
        // own default is never actually relied upon for a designer-created
        // line. defaultSource: 'designer' marks this for firmware-parity
        // tooling so it's reported as an intentional, documented divergence
        // rather than re-flagged as an incorrect default.
        auto_size: { type: 'bool', defaultSource: 'designer' },
        y_invert:  { type: 'bool', defaultSource: 'designer' },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 100, min_width: 10, min_height: 10,
            hidden: false, enabled: true,
            // See the defaultSource: 'designer' comment above — these are the
            // editor's authoring-convention defaults, not firmware's raw
            // lv_line_create() defaults (which are the inverse: 1 and 0).
            auto_size: 0, y_invert: 1,
        },
        styles: {
            // line_width: 1 — hasp_object.cpp:584 explicitly sets
            // lv_obj_set_style_local_line_width(obj, LV_LINE_PART_MAIN, LV_STATE_DEFAULT, 1)
            // at creation time (the HASP theme's own line_init() is empty).
            main: { line_color: '#ffffff', line_width: 1, line_rounded: false },
        },
    },
    states: ['pressed', 'disabled'],

    editorCapabilities:  ['can_copy'],
    runtimeCapabilities: [],

    events: {},
    bindings: { properties: {}, actions: { hass_services: [] }, events: {} },
}
